//Listen for cart actions - send Relewise tracking + set cart attributes
(function () {
    if (!window || !window.Shopify) return;
  
    const CartEvents = {
      add: "SCE:add",
      update: "SCE:update",
      change: "SCE:change",
      clear: "SCE:clear",
      mutate: "SCE:mutate",
    };
  
    const ShopifyCartURLs = [
      "/cart/add",
      "/cart/update",
      "/cart/change",
      "/cart/clear",
      "/cart/add.js",
      "/cart/update.js",
      "/cart/change.js",
      "/cart/clear.js",
    ];
  
    // Flag to prevent infinite loop
    let updatingCartAttributes = false;
  
    function isShopifyCartURL(url) {
      if (!url) return false;
      const path = url.split("/").pop();
      return ShopifyCartURLs.includes(`/cart/${path}`);
    }
  
    function updateType(url) {
      if (!url) return false;
      if (url.includes("cart/add")) {
        return "add";
      } else if (url.includes("cart/update")) {
        return "update";
      } else if (url.includes("cart/change")) {
        return "change";
      } else if (url.includes("cart/clear")) {
        return "clear";
      } else return false;
    }
  
    function dispatchEvent(url, detail) {
      if (typeof detail === "string") {
        try {
          detail = JSON.parse(detail);
        } catch {}
      }
  
      window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
      const type = updateType(url);
      switch (type) {
        case "add":
          window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
          break;
        case "update":
          window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
          break;
        case "change":
          window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
          break;
        case "clear":
          window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
          break;
        default:
          break;
      }
    }
  
    // Temporarily disable listeners
    function disableListeners() {
      window.XMLHttpRequest.prototype.open = originalOpen;
      window.fetch = originalFetch;
    }
  
    // Re-enable listeners
    function enableListeners() {
      fetchOverride();
      XHROverride();
    }
  
    // Override XMLHttpRequest to listen to cart events
    function XHROverride() {
      if (!window.XMLHttpRequest) return;
  
      window.XMLHttpRequest.prototype.open = function () {
        const url = arguments[1];
        this.addEventListener("load", function () {
          if (isShopifyCartURL(url)) {
            dispatchEvent(url, this.response);
            setCartAttributes();
          }
        });
        return originalOpen.apply(this, arguments);
      };
    }
  
    // Override fetch to listen to cart events
    function fetchOverride() {
      if (!window.fetch || typeof window.fetch !== "function") return;
      window.fetch = function () {
        const response = originalFetch.apply(this, arguments);
  
        if (isShopifyCartURL(arguments[0])) {
          response.then((res) => {
            res
              .clone()
              .json()
              .then((data) => {
                dispatchEvent(res.url, data);

                // If this is an add-to-cart action, update DrawerUpsaleProducts with the SKU(s) just added
                if (res.url.includes('/cart/add')) {
                  // Check if cart drawer is open
                  const cartDrawer = document.querySelector('cart-drawer');
                  const isDrawerOpen = cartDrawer && (cartDrawer.hasAttribute('open') || cartDrawer.classList.contains('is-open') || cartDrawer.open === true);
                    
                  if (isDrawerOpen) {
                    let skus = [];
                    if (Array.isArray(data)) {
                      skus = data.map(item => item.sku).filter(Boolean);
                    } else if (data && data.sku) {
                      skus = [data.sku];
                    }

                    // Fetch current cart to get existing DrawerUpsaleProducts attribute
                    fetch('/cart.js', { credentials: 'same-origin' })
                      .then(response => response.json())
                      .then(cart => {
                        let currentSkus = [];
                        if (cart.attributes && cart.attributes.DrawerUpsaleProducts) {
                          currentSkus = cart.attributes.DrawerUpsaleProducts.split(',').map(s => s.trim()).filter(Boolean);
                        }
                        // Merge and deduplicate
                        const updatedSkus = Array.from(new Set([...currentSkus, ...skus]));
                        // Update the cart attribute
                        const formDataToUpdate = {};
                        if (updatedSkus.length > 0) {
                          formDataToUpdate['attributes[DrawerUpsaleProducts]'] = updatedSkus.join(',');
                        } else {
                          formDataToUpdate['attributes[DrawerUpsaleProducts]'] = '';
                        }
                        fetch('/cart/update.js', {
                          method: 'POST',
                          credentials: 'same-origin',
                          headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                          },
                          body: new URLSearchParams(formDataToUpdate).toString(),
                        });
                      });
                  }
                } else {
                  // For other cart actions, you may want to clear or update the attribute as needed
                  setCartAttributes();
                }
              });
          });
        }
  
        return response;
      };
    }
  
    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalFetch = window.fetch;
  
    // Function to set cart attributes
    function setCartAttributes() {
      if (updatingCartAttributes) return;
      updatingCartAttributes = true;
    
      // Disable listeners to prevent recursion
      disableListeners();
    
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(response => response.json())
        .then(cart => {
          // Get all SKUs currently in the cart
          const cartSkus = (cart.items || []).map(item => item.sku).filter(Boolean);

          // Get current DrawerUpsaleProducts attribute as array
          let currentSkus = [];
          if (cart.attributes && cart.attributes.DrawerUpsaleProducts) {
            currentSkus = cart.attributes.DrawerUpsaleProducts.split(',').map(s => s.trim()).filter(Boolean);
          }

          // Filter out SKUs that are no longer in the cart
          const filteredSkus = currentSkus.filter(sku => cartSkus.includes(sku));

          // Prepare update payload
          const formDataToUpdate = {};
          if (filteredSkus.length > 0) {
            formDataToUpdate['attributes[DrawerUpsaleProducts]'] = filteredSkus.join(',');
          } else {
            formDataToUpdate['attributes[DrawerUpsaleProducts]'] = '';
          }

          // Only update if the attribute needs to change
          if (
            (filteredSkus.length > 0 && filteredSkus.join(',') !== currentSkus.join(',')) ||
            (filteredSkus.length === 0 && currentSkus.length > 0)
          ) {
            return fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: new URLSearchParams(formDataToUpdate).toString(),
            });
          }
          return null;
        })
        .catch(error => {
          console.error('Error updating DrawerUpsaleProducts attribute:', error);
        })
        .finally(() => {
          enableListeners();
          updatingCartAttributes = false;
        });
    }
  
    fetchOverride();
    XHROverride();
  })();
  
  